
/**
 * CENTRAL DOMAIN CONFIGURATION
 * Change these values to rebrand the application.
 */

export const DOMAIN_CONFIG = {
    // 1. The Main SaaS Marketing Site / Admin Dashboard
    // e.g. "saas.janoobistudios.com" or "myapp.com"
    SAAS_ROOT: 'saas.janoobistudios.com',
    
    // 2. The Base Domain for Tenant Portals (Subdomains)
    // SET TO NESTED: Uses *.s.partal.janoobistudios.com. 
    // This requires the external Proxy App we will build next.
    SAAS_PORTAL_BASE: 'portal.janoobistudios.com',
    
    // 3. The Marketplace Directory
    // e.g. "marketplace.saas.janoobistudios.com"
    SAAS_MARKETPLACE: 'marketplace.saas.janoobistudios.com',
    
    // 4. The Standalone Studio Domain (Single Tenant Mode)
    // e.g. "janoobistudios.com"
    STUDIO_STANDALONE: 'janoobistudios.com',
    STUDIO_STANDALONE_ALT: 'janoobistudios.online',

    // 5. Firebase Project ID (Used for default .web.app domains)
    FIREBASE_PROJECT_ID: 'janoobi-studio',

    // 6. The Fixed Tenant ID for the Standalone Studio
    STANDALONE_TENANT_ID: 'legacy_janoobi'
};

// Derived Helpers
export const IS_LOCALHOST = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const isSaaSPlatform = (hostname: string) => {
    return hostname === DOMAIN_CONFIG.SAAS_ROOT ||
           hostname === `www.${DOMAIN_CONFIG.SAAS_ROOT}` ||
           hostname === DOMAIN_CONFIG.SAAS_MARKETPLACE ||
           hostname === 'janoobistudios.web.app'; // Specific Firebase target for landing
};

export const isStandaloneStudio = (hostname: string) => {
    return hostname === DOMAIN_CONFIG.STUDIO_STANDALONE || 
           hostname === DOMAIN_CONFIG.STUDIO_STANDALONE_ALT;
};
